import { createTheme } from '@mui/material/styles';
import { PaletteMode } from '@mui/material';

// Extend PaletteMode to include 'blue'
declare module '@mui/material/styles' {
  interface Theme {
    customMode?: 'blue';
  }
  interface ThemeOptions {
    customMode?: 'blue';
  }
}
const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#aaa', // blue
      contrastText: '#A5ACB5',
    },
    secondary: {
      main: '#ffb300', // amber
      contrastText: '#000',
    },
    background: {
      paper: '#fff', // white
      default: '#f5f7fa', // very light blue/gray
    },
    text: {
      primary: '#22223b', // deep blue-gray
      secondary: '#333', // medium gray
    },
  },
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#000',
    },
    secondary: {
      main: '#f48fb1',
    },
    background: {
      // default: '#121212',
      default: '#1E1E1E',
      // paper: '#2B2B2B',
      paper: '#242424',
    },
  },
  // following is not working yet
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#1976d2', // replace with the color you want
          borderRight: 'none', // remove the right border
        },
      },
    },
  },
});



// #EED367, #F1F1F1, #CEE8FF
const blueTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#EED367', // yellow gold
      contrastText: '#000', // very light gray for contrast
    },
    secondary: {
      main: '#CEE8FF', // light blue
      contrastText: '#EED367', // yellow gold for contrast
    },
    background: {
      default: '#CEE8FF', // light blue for default background
      paper: '#F1F1F1', // light blue for paper
    },
    text: {
      primary: '#EED367', // yellow gold for primary text
      secondary: '#5A6B7A', // soft blue-gray for secondary text
    },
    error: {
      main: '#d32f2f',
    },
    warning: {
      main: '#EED367', // yellow gold for warning
    },
    info: {
      main: '#CEE8FF', // light blue for info
    },
    divider: '#EED367', // yellow gold for divider
  },
  
  customMode: 'blue',
});

// Theme registry for easy access
const themes = {
  light: lightTheme,
  dark: darkTheme,
  blue: blueTheme,
};

export { lightTheme, darkTheme, blueTheme, themes };
